import { useCallback, useState } from "react";

import {
  useFetchNfe,
  useAPINFE2,
  useAPIAuthenticateToast,
  useApiNfeFadel,
} from "hooks";
import { useAPIFadelFetch } from "hooks/useNfeFadel";

import { useAPIToast } from "hooks/useAPIToast";
import { getURLWithParams } from "utils/context";

// TODO: Retirar os usos de hooks com cancelamento

export const useTaxNotes = params =>
  useFetchNfe(params ? getURLWithParams("/tax-note", params) : null);

export const useTaxNotesTotais = params =>
  useFetchNfe(params ? getURLWithParams("/tax-note/totals", params) : null);

export const useTaxNotesDetail = params =>
  useFetchNfe(params ? getURLWithParams("/tax-note/details/", params) : null);

export const useFetchGetBookkeepingFactory = params =>
  useFetchNfe(params ? getURLWithParams("/nfe/bookkeeping/", params) : null);

export const useInvoiceGetProduto = params =>
  useFetchNfe(
    params ? getURLWithParams("/tax-note/details/produto", params) : null,
  );

export const useInvoiceXmls = params =>
  useFetchNfe(params ? getURLWithParams("/tax-note", params) : null);

export const useInvoiceGetXml = params =>
  useFetchNfe(params ? getURLWithParams("/tax-note", params) : null);

export const useInvoiceGetHistory = params =>
  useFetchNfe(
    params ? getURLWithParams("/tax-note/details/history", params) : null,
  );

export const useNfeDetailActions = () => {
  const { isLoading, onSend } = useAPIAuthenticateToast();

  const sendProcessItens = (data = {}) =>
    onSend({
      endpoint: getURLWithParams("/cronjobs/processa-cenarios", data),
      messageSuccess: "Produtos processados com sucesso!",
      messageFail: "Falha ao tentar processar os produtos da nota",
      type: "GET",
    });

  return {
    isLoading,
    sendProcessItens,
  };
};

export const useInvoiceGetXml3 = () => {
  const apiNfe = useAPINFE2();
  const [data, setData] = useState(undefined);
  const [loading, setLoading] = useState(true);

  const fetch = useCallback(
    (params = {}) => {
      setLoading(true);
      apiNfe
        .get(getURLWithParams("/tax-note/xml", params))
        .then(values => {
          setData(values?.data?.data);
          setLoading(false);
        })
        .catch(() => {
          setData(undefined);
          setLoading(false);
        });
    },
    [apiNfe],
  );

  return { isLoading: loading, data, fetch };
};

export const useInvoiceDetail = () => {
  const apiNfe = useAPINFE2();
  const [data, setData] = useState(undefined);
  const [loading, setLoading] = useState(true);

  const {
    data: dataXml,
    isLoading: isLoadingXml,
    fetch: fectchGetxml,
  } = useInvoiceGetXml3();

  const fetch = useCallback(
    (params = {}) => {
      setLoading(true);
      apiNfe
        .get(getURLWithParams("/tax-note/details/", params))
        .then(values => {
          fectchGetxml({
            id: params?.id,
          });
          setData(values?.data);
          setLoading(false);
        })
        .catch(() => {
          setData(undefined);
          setLoading(false);
        });
    },
    [apiNfe, fectchGetxml],
  );

  return {
    isLoading: loading,
    data,
    dataXml,
    isLoadingXml,
    fetch,
  };
};

export const useInvoiceDetailAsync = () => {
  const apiNfe = useAPINFE2();
  const [data, setData] = useState(undefined);
  const [loading, setLoading] = useState(true);

  const {
    data: dataXml,
    isLoading: isLoadingXml,
    fetch: fectchGetxml,
  } = useInvoiceGetXml();

  const fetch = useCallback(
    async (params = {}) => {
      setLoading(true);
      try {
        const values = await apiNfe.get(
          getURLWithParams("/tax-note/details/", params),
        );
        fectchGetxml({ id: params?.id });
        setData(values?.data);
        setLoading(false);
        return values?.data;
      } catch (error) {
        setData(undefined);
        setLoading(false);
      }
    },
    [apiNfe, fectchGetxml],
  );

  return { isLoading: loading, data, dataXml, isLoadingXml, fetch };
};

export const useInvoiceSearchingTotals = () => {
  const apiNfe = useAPINFE2();
  const [data, setData] = useState(undefined);
  const [totalPages, setTotalPages] = useState(undefined);
  const [loading, setLoading] = useState(true);

  const fetch = useCallback(
    (params = {}) => {
      setLoading(true);
      apiNfe
        .post("/tax-note/totals", {
          ...params,
        })
        .then(values => {
          setTotalPages(values?.data?.total_pages);
          setData(values?.data?.data);
          setLoading(false);
        })
        .catch(() => {
          setData(undefined);
          setTotalPages(undefined);
          setLoading(false);
        });
    },
    [apiNfe],
  );

  return { isLoading: loading, data, totalPages, fetch };
};

export const useInvoiceSearching = () => {
  const apiNfe = useAPINFE2();
  const [data, setData] = useState(undefined);
  const [loading, setLoading] = useState(true);

  const {
    isLoading: isLoadingTotals,
    data: dataTotals,
    totalPages,
    fetch: fetchTotals,
  } = useInvoiceSearchingTotals();

  const fetch = useCallback(
    (params = {}) => {
      setLoading(true);
      apiNfe
        .post("/tax-note", {
          ...params,
        })
        .then(values => {
          fetchTotals({ ...params });
          setData(values?.data);
          setLoading(false);
        })
        .catch(() => {
          setData(undefined);
          setLoading(false);
        });
    },
    [apiNfe, fetchTotals],
  );

  return {
    isLoading: loading,
    data,
    dataTotals: dataTotals?.[0],
    totalPages,
    isLoadingTotals,
    fetch,
  };
};

export const useNoteDetailBokkeeping = params =>
  useFetchNfe(getURLWithParams("/nfe/bookkeeping", params));

export const useTaxNoteDownload = params =>
  useFetchNfe(params ? getURLWithParams("/tax-note/download", params) : null);

export const useGenerateDanfe = () => {
  const api = useApiNfeFadel();
  const { onSend, isLoading, data } = useAPIToast(api);

  const onGenerateDanfe = data =>
    onSend({
      endpoint: "/gerar-danfe-pdf",
      messageSuccess: "Danfe gerado com successo",
      messageFail: "Falha ao tentar gerar danfe",
      type: "POST",
      data,
    });

  return {
    onGenerateDanfe,
    data: data?.url,
    isLoading,
  };
};

export const useTaxNoteManifestList = params =>
  useAPIFadelFetch("/evento/manifestacao/list", {
    method: "POST",
    data: params,
  });

export const useTaxNoteManifest = () => {
  const api = useApiNfeFadel();
  const { onSend, isLoading, data } = useAPIToast(api);

  const onSendManifest = (data, text) =>
    onSend({
      endpoint: "/evento/manifestacao",
      messageSuccess: `Manifesto de ${text} enviado!`,
      messageFail: `Falha no envio do manifesto de ${text}`,
      type: "POST",
      data,
    });

  const onGetManifestEvent = data =>
    onSend({
      endpoint: "/evento/manifestacao/list",
      type: "POST",
      toast: false,
      data,
    });

  return {
    onGetManifestEvent,
    onSendManifest,
    isLoading,
    data,
  };
};
